module.exports = __webpack_public_path__ + "img/banner.5e608008.jpg";